module.exports = __webpack_public_path__ + "img/img-1.47558cf8.png";